interface SkuConfig {
  name?: string
  isAnnualContract?: boolean
  isPersonal?: boolean
  seatsSKU?: string
  seatNameSingular?: string
  seatNamePlural?: string
  fullSeatDescription?: string
  defaultSubscriptionBundle?: boolean
  subscriptionGroup?: string
  altPlanSkus?: string[]
}

export const SKU_CONFIG: Record<string, SkuConfig> = {
  PRO_MEMBERSHIP_BASE_MONTHLY: {
    isAnnualContract: true,
    seatsSKU: "PRO_MEMBERSHIP_BASE_ADD_SEATS",
    seatNameSingular: "Headset",
    seatNamePlural: "Headsets",
    fullSeatDescription: "Access per Headset",
  },

  PRO_MEMBERSHIP_BOOST_MONTHLY: {
    altPlanSkus: ["PRO_MEMBERSHIP_BASE_MONTHLY"],
  },

  MEMBERSHIP_YEARLY: {
    name: "Personal Membership",
    isPersonal: true,
    defaultSubscriptionBundle: true,
    subscriptionGroup: "personal",
    altPlanSkus: ["MEMBERSHIP_YEARLY_FAMILY", "MEMBERSHIP_YEARLY_DUO"],
  },

  MEMBERSHIP_MONTHLY: {
    isPersonal: true,
    altPlanSkus: [
      "MEMBERSHIP_YEARLY",
      "MEMBERSHIP_YEARLY_FAMILY",
      "MEMBERSHIP_YEARLY_DUO",
    ],
  },

  MEMBERSHIP_YEARLY_FAMILY: {
    isPersonal: true,
    subscriptionGroup: "personal",
    altPlanSkus: ["MEMBERSHIP_YEARLY", "MEMBERSHIP_YEARLY_DUO"],
  },

  MEMBERSHIP_YEARLY_DUO: {
    isPersonal: true,
    subscriptionGroup: "personal",
    altPlanSkus: ["MEMBERSHIP_YEARLY", "MEMBERSHIP_YEARLY_FAMILY"],
  },
}
